export default function services() {
  return (
    <>
 
    <section id="services" className="services">

      <div className="container" data-aos="fade-up">

        <header className="section-header">
          <h2>Services</h2>
          <p>Our Popular Services</p>
        </header>

        <div className="row gy-4">

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div className="service-box blue">
              <i className="ri-layout-4-line icon"></i>
              <h4>Website Design and Development</h4>
             <p>Get custom, responsive, and SEO-friendly websites that drive results. I design fast, secure, and conversion-focused websites.</p>
              <a href="/website-design-and-development" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
            <div className="service-box orange">
              <i className="ri-article-line icon"></i>
              <h4>Content Marketing</h4>
             <p>Engage your audience with SEO-driven blogs, articles, and content strategies. I craft valuable content to boost brand visibility and organic traffic.</p>
              <a href="/content-marketing" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
            <div className="service-box green">
              <i className="ri-mail-send-line icon"></i>
              <h4>Email Marketing</h4>
              <p>Reach your audience directly with high-converting email campaigns. I create personalized email strategies to boost engagement and customer retention.</p>
              <a href="/email-marketing" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
            <div className="service-box red">
              <i className="ri-share-line icon"></i>
              <h4>Social Media Marketing</h4>
              <p>Grow your brand with targeted social media strategies. I manage content, ads, and engagement across platforms like Facebook, Instagram, and LinkedIn.</p>
              <a href="/social-media-marketing" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
            <div className="service-box purple">
              <i className="ri-search-eye-line icon"></i>
              <h4>Search Engine Optimization (SEO)</h4>
              <p>Improve your Google rankings with expert on-page and technical SEO. I help businesses in Gurgaon gain visibility and organic website traffic.</p>
              <a href="/search-engine-optimization" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="700">
            <div className="service-box pink">
              <i className="ri-bill-line icon"></i>
              <h4>Pay-Per-Click (PPC) Advertising</h4>
              <p>Generate instant traffic with ROI-focused Google Ads and PPC campaigns. I set up and optimize ads to increase leads and sales fast.</p>
              <a href="/pay-per-click-advertising" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>
           <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="800">
            <div className="service-box orange">
              <i className="ri-smartphone-line icon"></i>
              <h4>Responsive Design</h4>
              <p>I design responsive, mobile-first interfaces for all screen sizes. Ensure your website looks perfect on mobile, tablet, and desktop devices.</p>
              <a href="/responsive-design" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="900">
            <div className="service-box green">
              <i className="ri-brush-line icon"></i>
              <h4>PSD Design</h4>
             <p>Professional designs for logos, banners, business cards, and more. I deliver creative PSD designs using Adobe Photoshop within 24 hours.</p>
              <a href="/psd-design" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>
           <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="1000">
            <div className="service-box violet">
              <i className="ri-shield-user-line icon"></i>
              <h4>Online Reputation Management</h4>
             <p>Protect your online brand with proactive review and feedback management. I monitor and manage your reputation to build trust and credibility.</p>
              <a href="/online-reputation-management" className="read-more"><span>Read More</span> <i className="bi bi-arrow-right"></i></a>
            </div>
          </div>

{/*

Latest Web Design Trends
Dark Mode: Dark mode is becoming increasingly popular, thanks to its energy-saving benefits and its ability to create a dramatic effect. It is also easier on the eyes, especially in low-light environments.

Minimalism: Minimalistic designs with clean lines, white space, and simple typography are gaining popularity. They offer a clean and organized look that is easy on the eyes and enhances the user experience.

Responsive Design: With the growing use of mobile devices, responsive design has become a must for websites. Responsive design ensures that your website looks good and functions well on all devices, including desktops, tablets, and smartphones.

3D Graphics: 3D graphics are becoming more prevalent in web design, thanks to the advancements in technology. They add depth and interactivity to your website, making it more engaging for users.

Motion Design: Motion design refers to the use of animations, transitions, and videos to enhance the user experience. They can be used to draw attention to specific elements, create a sense of continuity, and improve overall user engagement.





What are website design services?
Website design services are professional services that assist businesses in designing, developing, and maintaining their websites. These services include a range of tasks, such as website layout, graphics design, content creation, and website functionality. The ultimate goal of website design services is to create a website that aligns with the business's goals and caters to its target audience.

Benefits of website design services
There are several benefits of using website design services. Some of them include:

Professionalism
Professional website design services can ensure that your website looks and feels professional. A professionally designed website can instill confidence in potential customers and encourage them to interact with your business.

Customization
Website design services can tailor your website to meet the specific needs of your business. They can incorporate your brand's colors, logos, and imagery to create a cohesive brand identity.

Optimization
Website design services can optimize your website for search engines, making it easier for potential customers to find your business online. They can also ensure that your website is mobile-friendly and easy to navigate.

Time-saving
Designing a website can be time-consuming, especially for business owners who lack the technical expertise. By outsourcing website design services, businesses can save time and focus on their core business activities.

Choosing the right website design service
Choosing the right website design service is critical to the success of your online presence. Here are some factors to consider when choosing a website design service:

Experience
Look for a website design service that has experience in designing websites for businesses similar to yours. This can ensure that they have the necessary expertise to create a website that aligns with your business goals.

Portfolio
A website design service's portfolio can give you an idea of their capabilities and design style. Check their portfolio to see if they have experience designing websites that align with your business goals.

Communication
Effective communication is crucial when working with a website design service. Choose a service that has open lines of communication and is willing to work with you to achieve your goals.

Cost
Website design services vary in cost, depending on the complexity of the website and the service provider's expertise. Choose a service that offers a fair price and fits within your budget.



The website design process
The website design process typically involves several steps:

Discovery
The website design service will meet with the business owner to discuss their goals and requirements for the website. They will also analyze the target audience and competitors to determine the best approach to the design.

Design
The website design service will create a design concept for the website, including the layout, color scheme, and typography. The business owner will have the opportunity to provide feedback and make revisions.

Development
Once the design is finalized, the website design service will develop the website's functionality, including coding and testing. They will also optimize the website for search engines and mobile devices.

Launch
After the website has been developed and tested, it is ready to be launched. The website design service will ensure that the website is properly configured and functional.

Maintenance
Website design services also offer maintenance and support services to ensure that the website remains functional and up-to-date.
*/}


        </div>
      </div>
    </section>
    </>
  );
}
